import React from 'react';
import './LinearSlider.css';

// Add an array of images for the slider
import slider1 from '../../Assets/Image1.png';
import slider2 from '../../Assets/Image2.png';
import slider3 from '../../Assets/Image3.png';
import slider4 from '../../Assets/Image4.png';
import slider5 from '../../Assets/Image5.png';
import slider6 from '../../Assets/Image6.png';
import slider7 from '../../Assets/Image7.png';
import slider8 from '../../Assets/Image8.png';


function LinearSlider() {
  return (
    <div className="slider-container">
      <div className="slider-track">
        {/* Map over images to create the slider */}
        {[slider1, slider2, slider3, slider4, slider5, slider6, slider7 , slider8, slider1, slider2, slider3, slider4, slider5, slider6, slider7, slider8].map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`slider-${index}`}
            className="slider-size"
          />
        ))}
      </div>
    </div>
  );
}

export default LinearSlider;
